module.exports = {
  RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_REQUEST',
  RETRIEVE_INBOUND_POSTAL_OPERATOR_SUCCESS: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_SUCCESS',
  RETRIEVE_INBOUND_POSTAL_OPERATOR_FAILURE: 'RETRIEVE_INBOUND_POSTAL_OPERATOR_FAILURE',
  ARRIVAL_MAIL_PROCESSING_CENTER_CHECKED: 'ARRIVAL_MAIL_PROCESSING_CENTER_CHECKED',
  ARRIVAL_POSTAL_OPERATOR_EXPANDED: 'ARRIVAL_POSTAL_OPERATOR_EXPANDED',
  SELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS: 'SELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS',
  SELECT_ALL_ARRIVAL_OPERATORS: 'SELECT_ALL_ARRIVAL_OPERATORS',
  DESELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS: 'DESELECT_ALL_ARRIVAL_MAIL_PROCESSING_CENTERS',
  DESELECT_ALL_ARRIVAL_OPERATORS: 'DESELECT_ALL_ARRIVAL_OPERATORS',
};
